// import React, { useRef, useState } from "react";

// const StateCarousel = () => {
//   const scrollRef = useRef(null);
//   const [active, setActive] = useState(0);

//   const states = [
//     "Andhra Pradesh",
//     "Telangana",
//     "Karnataka",
//     "Tamil Nadu",
//     "Kerala",
//     "Maharashtra",
//     "Gujarat",
//     "Rajasthan",
//     "Delhi",
//     "West Bengal",
//     "Punjab",
//     "Haryana",
//   ];

//   const scroll = (direction) => {
//     const cardWidth = 220;

//     if (scrollRef.current) {
//       scrollRef.current.scrollBy({
//         left: direction === "left" ? -cardWidth : cardWidth,
//         behavior: "smooth",
//       });

//       setActive((prev) =>
//         direction === "left"
//           ? Math.max(prev - 1, 0)
//           : Math.min(prev + 1, states.length - 1)
//       );
//     }
//   };

//   return (
//     <>
//       {/* Styles */}
//       <style>{`
//         .carousel-wrapper {
//           width: 100%;
//           padding: 40px 20px;
//           background: #fff;
//           font-family: Arial, sans-serif;
//         }

//         .title {
//           font-size: 24px;
//           font-weight: 600;
//           margin-bottom: 20px;
//         }

//         .carousel-container {
//           position: relative;
//           display: flex;
//           align-items: center;
//         }

//         .carousel {
//           display: flex;
//           gap: 16px;
//           overflow: hidden;
//           scroll-behavior: smooth;
//           padding: 10px 0;
//         }

//         .card {
//           min-width: 200px;
//           height: 120px;
//           background: #ffffff;
//           border-radius: 14px;
//           box-shadow: 0 6px 18px rgba(0,0,0,0.1);
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           transition: transform 0.3s;
//         }

//         .card:hover {
//           transform: translateY(-4px);
//         }

//         .illustration {
//           width: 80px;
//           height: 50px;
//           background: #f3f3f3;
//           border-radius: 6px;
//           margin-bottom: 8px;
//         }

//         .card p {
//           font-size: 16px;
//           font-weight: 500;
//           color: #333;
//         }

//         .nav-btn {
//           position: absolute;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           background: #fff;
//           border: none;
//           box-shadow: 0 4px 10px rgba(0,0,0,0.15);
//           cursor: pointer;
//           font-size: 18px;
//           z-index: 10;
//         }

//         .nav-btn.left {
//           left: -20px;
//         }

//         .nav-btn.right {
//           right: -20px;
//         }

//         .dots {
//           display: flex;
//           justify-content: center;
//           margin-top: 16px;
//           gap: 8px;
//         }

//         .dot {
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: #f2d9b1;
//         }

//         .dot.active {
//           background: #f5a623;
//         }
//       `}</style>

//       {/* Component */}
//       <div className="carousel-wrapper">
//         <div className="title">Explore Properties by State</div>

//         <div className="carousel-container">
//           <button className="nav-btn left" onClick={() => scroll("left")}>
//             ←
//           </button>

//           <div className="carousel" ref={scrollRef}>
//             {states.map((state, index) => (
//               <div className="card" key={index}>
//                 <div className="illustration"></div>
//                 <p>{state}</p>
//               </div>
//             ))}
//           </div>

//           <button className="nav-btn right" onClick={() => scroll("right")}>
//             →
//           </button>
//         </div>

//         <div className="dots">
//           {states.map((_, index) => (
//             <span
//               key={index}
//               className={`dot ${active === index ? "active" : ""}`}
//             />
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default StateCarousel;

import React, { useRef, useState } from "react";
import "./StateCarousel.css";
import { useNavigate } from "react-router-dom";

// const states = [
//   { name: "Telangana", image: "https://realrupee.com/resources/images/thumbnails/Hyderabad.png" },
//   { name: "Delhi", image: "https://realrupee.com/resources/images/thumbnails/Delhi.png" },
//   { name: "Bangalore", image:"https://realrupee.com/resources/images/thumbnails/Bangalore.png"},
//   { name: "Chennai", image:"https://realrupee.com/resources/images/thumbnails/Chennai.png"},
//   { name: "Pune", image:"https://realrupee.com/resources/images/thumbnails/Pune.png"},
//   { name: "Kolkata", image:"https://realrupee.com/resources/images/thumbnails/Kolkata.png"},
//   { name: "Mumbai", image:"https://realrupee.com/resources/images/thumbnails/Mumbai.png"},
//   { name: "Visakhapatnam", image:"https://realrupee.com/resources/images/thumbnails/Visakhapatnam.png"},
//   { name: "Vijayawada", image:"https://realrupee.com/resources/images/thumbnails/Vijayawada.png"},
//   { name: "Ahmedabad", image:"https://realrupee.com/resources/images/thumbnails/Ahmedabad.png"},
// ];

const properties = [
  {
    id: 1,
    title: "Premium Downtown Commercial Plot",
    location: "Downtown Business District",
    price: "₹2,50,00,000",
    area: "5000 sq ft",
    type: "Commercial",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
    premium: true
  },
  {
    id: 2,
    title: "Luxury Corporate Office Space",
    location: "Financial Hub",
    price: "₹3,80,00,000",
    area: "6200 sq ft",
    type: "Commercial",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c",
    premium: true
  },
  {
    id: 3,
    title: "Modern Business Tower",
    location: "Tech Park",
    price: "₹1,95,00,000",
    area: "4200 sq ft",
    type: "Commercial",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e",
    premium: false
  }
];


const states = [
  { name: "Andhra Pradesh", image: "https://placehold.co/300x200?text=Andhra+Pradesh" },
  { name: "Arunachal Pradesh", image: "https://placehold.co/300x200?text=Arunachal+Pradesh" },
  { name: "Assam", image: "https://placehold.co/300x200?text=Assam" },
  { name: "Bihar", image: "https://placehold.co/300x200?text=Bihar" },
  { name: "Chhattisgarh", image: "https://placehold.co/300x200?text=Chhattisgarh" },
  { name: "Goa", image: "https://placehold.co/300x200?text=Goa" },
  { name: "Gujarat", image: "https://placehold.co/300x200?text=Gujarat" },
  { name: "Haryana", image: "https://placehold.co/300x200?text=Haryana" },
  { name: "Himachal Pradesh", image: "https://placehold.co/300x200?text=Himachal+Pradesh" },
  { name: "Jharkhand", image: "https://placehold.co/300x200?text=Jharkhand" },
  { name: "Karnataka", image: "https://placehold.co/300x200?text=Karnataka" },
  { name: "Kerala", image: "https://placehold.co/300x200?text=Kerala" },
  { name: "Madhya Pradesh", image: "https://placehold.co/300x200?text=Madhya+Pradesh" },
  { name: "Maharashtra", image: "https://placehold.co/300x200?text=Maharashtra" },
  { name: "Manipur", image: "https://placehold.co/300x200?text=Manipur" },
  { name: "Meghalaya", image: "https://placehold.co/300x200?text=Meghalaya" },
  { name: "Mizoram", image: "https://placehold.co/300x200?text=Mizoram" },
  { name: "Nagaland", image: "https://placehold.co/300x200?text=Nagaland" },
  { name: "Odisha", image: "https://placehold.co/300x200?text=Odisha" },
  { name: "Punjab", image: "https://placehold.co/300x200?text=Punjab" },
  { name: "Rajasthan", image: "https://placehold.co/300x200?text=Rajasthan" },
  { name: "Sikkim", image: "https://placehold.co/300x200?text=Sikkim" },
  { name: "Tamil Nadu", image: "https://placehold.co/300x200?text=Tamil+Nadu" },
  { name: "Telangana", image: "https://placehold.co/300x200?text=Telangana" },
  { name: "Tripura", image: "https://placehold.co/300x200?text=Tripura" },
  { name: "Uttar Pradesh", image: "https://placehold.co/300x200?text=Uttar+Pradesh" },
  { name: "Uttarakhand", image: "https://placehold.co/300x200?text=Uttarakhand" },
  { name: "West Bengal", image: "https://placehold.co/300x200?text=West+Bengal" }
];




const CARD_WIDTH = 220;

const StateCarousel = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const scroll = (direction) => {
    if (!scrollRef.current) return;

    const scrollAmount =
      direction === "left" ? -CARD_WIDTH : CARD_WIDTH;

    scrollRef.current.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });

    setActiveIndex((prev) =>
      direction === "left"
        ? Math.max(prev - 1, 0)
        : Math.min(prev + 1, states.length - 1)
    );
  };
const navigate = useNavigate();

  return (
    <div className="carousel-wrapper">
      <h2 className="carousel-title">Explore Properties by State</h2>
      <div className="carousel-container">
        <button className="nav-btn left" onClick={() => scroll("left")}>
          &#8592;
        </button>

        <div className="carousel" ref={scrollRef}>
          {states.map((state, index) => (
            <div className="state-card" key={index}
            onClick={() =>
  navigate(`/state/${encodeURIComponent(state.name)}`)
}

>
              <img src={state.image} alt={state.name} />
              <p>{state.name}</p>
            </div>
          ))}
        </div>

        

        <button className="nav-btn right" onClick={() => scroll("right")}>
          &#8594;
        </button>
      </div>

      {/* <div className="dots">
        {states.map((_, index) => (
          <span
            key={index}
            className={`dot ${activeIndex === index ? "active" : ""}`}
          />
        ))}
      </div> */}
    </div>
  );
};

export default StateCarousel;
